import request from '@/utils/request'
let Base64 = require('js-base64').Base64;

// 根据参数键名查询参数值
export function getConfigKey(configKey) {
    return request({
        url: '/system/config/configKey/' + configKey,
        method: 'get'
    })
}

// 检查应用版本
export function getApp() {
    return request({
        url: '/system/appversion/checkVersion',
        method: 'get',
        params: {
            appId: 'gjmc-app-android',
            appVersion: '0.0.0',
        }
    })
}

// 文件预览
export function filePreview(url) {
    if (!url) {
        this.$message.error("文件地址不可为空");
        return;
    }
    window.open(url, "_blank");
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/system/dict/data/type/' + dictType,
        method: 'get'
    })
}
